import Vue from 'vue'
import SModal from './SModal.vue'
import './index.less'

SModal.install = (Vue) => {
  Vue.component(SModal.name, SModal)
}
Vue.prototype.$modal = (options) => {
  const { content, maskClosable, style } = options
  // 获取自定义内容
  const customVnode = content ? content() : ''
  let mountElement = null
  const tempCompConstructor = {
    mounted () {
      setTimeout(() => {
        this.visible = true
      }, 0)
    },
    data () {
      return {
        visible: false
      }
    },
    render (h) {
      return h('div', { class: 's-modal' }, [h(SModal, {
        props: {
          visible: this.visible,
          maskClosable: !!maskClosable
        },
        on: {
          cancel: () => {
            this.visible = false
          }
        },
        style
      }, [customVnode])])
    },
    methods: {
      close () {
        this.visible = false
        setTimeout(() => {
          const appEle = document.querySelector('#app')
          appEle.removeChild(appEle.querySelector('.s-modal'))
          this.$destroy()
        }, 500)
      }
    }
  }
  const smodalInstance = new Vue(tempCompConstructor)
  mountElement = document.createElement('div')
  const appEle = document.querySelector('#app')
  console.log(appEle)
  appEle.appendChild(mountElement)
  smodalInstance.$mount(mountElement)
  // smodalInstance.$nextTick(() => {
  //   smodalInstance.visible = true
  // })
  // setTimeout(() => {
  //   smodalInstance.visible = true
  // }, 0)
  return smodalInstance
}
Vue.prototype.$info = function (options) {
  const { content, okText, help, cancleText, onOk } = options
  // 获取自定义内容
  const customVnode = content ? content(new Vue({}).$createElement) : ''
  let mountElement = null
  const tempCompConstructor = {
    created () {
      this.init()
    },
    mounted () {
      setTimeout(() => {
        this.visible = true
      }, 0)
    },
    data () {
      return {
        visible: false,
        presetVnode: undefined,
        a: 1
      }
    },
    render (h) {
      return h('div', { class: 's-modal s-info' }, [h(SModal, {
        props: {
          visible: this.visible
        }
      }, [this.presetVnode])])
    },
    methods: {
      close () {
        this.visible = false
        setTimeout(() => {
          document.body.removeChild(document.body.querySelector('.s-modal'))
          this.$destroy()
        }, 500)
      },
      createPresetVnode () {
        this.presetVnode = (
          <div class="modal-tip">
            {
              help ? (
                <div class="question"></div>
              ) : ('')
            }
            <div class="text">
              { customVnode }
            </div>
            <div class="btn-group" class={cancleText ? 'witchcancle' : ''}>
              {
                cancleText ? (
                  <s-button class="btn-ok gray btn-cancel" onClick={this.close.bind(this)}>{ cancleText }</s-button>
                ) : ('')
              }
              <s-button class="btn-ok" onClick={onOk ? this.onOk.bind(this, onOk) : this.close.bind(this)}>{ okText }</s-button>
            </div>

          </div>
        )
      },
      init () {
        this.createPresetVnode()
      },
      onOk (callFun) {
        console.log('=========')
        // this.visible = false
        // setTimeout(() => {
        //   document.body.removeChild(document.body.querySelector('.s-modal'))
        //   this.$destroy()
        // }, 500)
        // // return this.close
        this.close()
        return callFun.call(this)
      }
    }
  }
  const smodalInstance = new Vue(tempCompConstructor)
  mountElement = document.createElement('div')
  document.body.appendChild(mountElement)
  smodalInstance.$mount(mountElement)
  return smodalInstance
}
Vue.prototype.$tip = function (options) {
  const { content } = options
  // 获取自定义内容

  let mountElement = null
  const tempCompConstructor = {
    mounted () {
      setTimeout(() => {
        this.visible = true
      }, 0)
    },
    data () {
      return {
        visible: false
      }
    },
    render (h) {
      const customVnode = (
        <div class="modal-tip">
          <div class="text">
            { content }
          </div>
        </div>
      )
      return h('div', { class: 's-modal s-toast' }, [h(SModal, {
        props: {
          visible: this.visible
        }
      }, [customVnode])])
    }
  }
  const smodalInstance = new Vue(tempCompConstructor)
  mountElement = document.createElement('div')
  document.body.appendChild(mountElement)
  smodalInstance.$mount(mountElement)
  setTimeout(() => {
    smodalInstance.visible = false
  }, 1200)
  return smodalInstance
}
Vue.prototype.$confirm = function (options) {
  const { content, title, titleTip, size } = options
  // 获取自定义内容
  const customVnode = content ? content(new Vue({}).$createElement) : ''
  let mountElement = null
  const tempCompConstructor = {
    created () {
      this.init()
    },
    mounted () {
      setTimeout(() => {
        this.visible = true
      }, 0)
    },
    data () {
      return {
        visible: false,
        presetVnode: undefined,
        a: 1
      }
    },
    render (h) {
      return h('div', { class: `s-modal s-confirm ${size === 'large' ? 's-confirm--l' : ''}` }, [h(SModal, {
        props: {
          visible: this.visible
        }
      }, [this.presetVnode])])
    },
    methods: {
      close () {
        this.visible = false
        setTimeout(() => {
          document.body.removeChild(document.body.querySelector('.s-modal'))
          this.$destroy()
        }, 500)
      },
      createPresetVnode () {
        this.presetVnode = (
          <div class="modal-tip">
            <i class="icon icon-close" onClick={this.close.bind(this)}/>
            <div class="title">{title}</div>
            <div class="title-tip">{titleTip}</div>
            <div class="content">
              { customVnode }
            </div>
            {/* <s-button class="btn-ok" class={size} onClick={this.close.bind(this)}>{ okText }</s-button> */}
          </div>
        )
      },
      init () {
        this.createPresetVnode()
      }
    }
  }
  const smodalInstance = new Vue(tempCompConstructor)
  mountElement = document.createElement('div')
  document.body.appendChild(mountElement)
  smodalInstance.$mount(mountElement)
  return smodalInstance
}
export default SModal
